// chat state (relates to updating chat in the sidebar for your current space/room when getting updates from the message queue)
// documentation link tbc

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  // live chat feed
  async updateChatFeed({getters, dispatch, commit}, {data}) {
    // if chat panel not visible when message comes in, show red dot in sidebar
    if(getters['sidebar/panelId'] !== 'chats') commit('setNewChatWaiting', true);
    else {
      let messageData = {...data}
      let isAdmin = getters['current_user/isAreaAdmin']
      let isAuthor = messageData.author.id === getters['current_user/id']
      messageData.canDelete = isAuthor || isAdmin
      await dispatch('addToBottomOfCurrentChatMessages', [messageData]);
      commit('setIfScrollToBottomOfChat', true);
    }
  },
  //live chat updates when a message gets deleted
  async removeMessageFromChatFeed({getters, dispatch}, {data}) {
    if(getters.getChatLocation.id === data.destinationId) {
      let deletedMessageId = data.data.messageId
      let currentMessages = getters.getCurrentChatMessages
      let newMessages = []
      currentMessages.forEach(message => {
        if(message.id !== deletedMessageId) {
          newMessages.push(message)
        }
      })
      dispatch('updateCurrentChatMessages', newMessages)
    }
  },
  //live chat updates when the whole chat is cleared
  async clearChatFeed({getters, dispatch}, {data}) {
    if(getters.getChatLocation.id === data.destinationId) {
      dispatch('clearChatMessages')
    }
  },

  //live chat updates when a user reacts to a message
  async updateChatMessageReactions({getters, dispatch}, {data}) {
    if(getters.getChatLocation.id === data.destinationId) {
      let currentUserId = getters['current_user/id']
      let updateMessageId = data.data.messageId
      let userReactId = data.data.userId
      let updatedReactionName = data.data.reactionName
      let updatedReactionCount = data.data.reactionCount
      let updatedReactionState = data.data.state

      let currentMessages = getters.getCurrentChatMessages
      let newMessages = []
      currentMessages.forEach(message => {
        if(message.id === updateMessageId) {
          message.totalReactions = data.data.totalReactions
          let reactions = message.reactions ? [...message.reactions] : []
          let ifReactionExists = false
          let newReactions = []
          //if reaction type is already in array - update values
          reactions.forEach(reaction => {
            let newReaction = {...reaction}
            if(reaction.reactionName == updatedReactionName) {
              newReaction.totalReactions = updatedReactionCount
              if(userReactId === currentUserId) {
                newReaction.userReacted = updatedReactionState
              }
              ifReactionExists = true
            }
            newReactions.push(newReaction)
          })
          //if reaction is not in array yet - add object with new values
          if(!ifReactionExists) {
            let newReactionObj = {
              reactionName: updatedReactionName,
              totalReactions: updatedReactionCount,
            }
            if(userReactId === currentUserId) {
              newReactionObj.userReacted = updatedReactionState
            }
            newReactions.push(newReactionObj)
          }
          //update reactions for the message
          message.reactions = newReactions
        }
        newMessages.push(message)
      })
      dispatch('updateCurrentChatMessages', newMessages)
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
